/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

const breadcrumbs = ({ typography: { size }, breakpoints }) => ({
    display: "none",

    [breakpoints.up("sm")]: {
        display: "inline-block !important"
    },
});

function Breadcrumbs({ icon, light, homePage }) {
    const route = useLocation().pathname.split("/").slice(1);
    const routes = route.slice(1, route.length - 1);

    const renderRoutes = routes.map((el, index) => {
        let returnValue;
        let link = routes.slice(0, index + 1)

        returnValue = (
            <Link
                to={`${homePage}/${link.join('/')}`}
                key={index}>
                <ArgonTypography
                    component="span"
                    variant="button"
                    fontWeight="regular"
                    textTransform="uppercase"
                    color={light ? "white" : "dark"}
                    opacity={light ? 0.8 : 0.5}
                    sx={{ lineHeight: 0 }}
                >
                    {el.replace("-", " ")}
                </ArgonTypography>
            </Link>
        )

        return returnValue
    })

    return (
        <ArgonBox mr={{ xs: 0, xl: 8 }} sx={breadcrumbs}>
            <MuiBreadcrumbs
                sx={{
                    "& .MuiBreadcrumbs-separator": {
                        color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
                    },
                }}
            >
                <Link to={homePage}>
                    <ArgonTypography
                        component="span"
                        variant="body2"
                        color={light ? "white" : "dark"}
                        opacity={light ? 0.8 : 0.5}
                        sx={{ lineHeight: 0 }}
                    >
                        <Icon>{icon}</Icon>
                    </ArgonTypography>
                </Link>
                {renderRoutes}
                <ArgonTypography
                    variant="button"
                    fontWeight="regular"
                    textTransform="uppercase"
                    color={light ? "white" : "dark"}
                    sx={{ lineHeight: 0 }}
                >
                    {route.length > 1 ? route[route.length - 1].replace("-", " ") : 'DASHBOARD'}
                </ArgonTypography>
            </MuiBreadcrumbs>
            <ArgonTypography
                fontWeight="bold"
                textTransform="capitalize"
                variant="h6"
                color={light ? "white" : "dark"}
                noWrap
            >
                {route.length > 1 ? route[route.length - 1].replace("-", " ") : 'Dashboard'}
            </ArgonTypography>
        </ArgonBox>
    );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
    light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
    icon: PropTypes.node.isRequired,
    // title: PropTypes.string.isRequired,
    // route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    light: PropTypes.bool,
};

export default Breadcrumbs;
